var render = function render(){var _vm=this,_c=_vm._self._c;return _c('robotKms',{attrs:{"app":"aff","appAuth":"aicc-autofillform","customColumn":_vm.customColumn,"answerInput":_vm.answerInput},on:{"queryData":_vm.queryData,"setAnswerInput":_vm.setAnswerInput,"saveData":_vm.saveData,"updateData":_vm.updateData,"deleteData":_vm.deleteData}})
}
var staticRenderFns = []

export { render, staticRenderFns }